import { ChevronRightIcon } from '@chakra-ui/icons'
import { AspectRatio, Box, Button, HStack, Text } from '@chakra-ui/react'

import Image from 'next/image'
import Link from 'next/link'

const Order = () => {
  return (
    <HStack
      w={600}
      h={{
        base: 375,
        sm: 445,
        md: 584
      }}
      position="relative"
      justifyContent="flex-start"
      alignItems="flex-start"
      pl={20}
      mt={{
        base: 1,
        sm: 2,
        md: 4
      }}
    >
      <AspectRatio
        mt={5}
        w={{
          base: 150,
          sm: 200,
          md: 300
        }}
        ratio={1 / 1}
        position="relative"
        ml={{
          base: '80px',
          sm: 10,
          md: 0
        }}
      >
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-skin-1711001106456.png"
          alt="bg skin"
          fill
        />
      </AspectRatio>

      <Box
        position="absolute"
        top="28%"
        left={{
          base: '100px',
          sm: 20,
          md: 10
        }}
      >
        <AspectRatio
          mt={5}
          w={{
            base: 250,
            sm: 300,
            md: 400
          }}
          ratio={1 / 1}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/girl-skin-1711001106455.png"
            alt="girl skin"
            fill
          />
        </AspectRatio>
      </Box>

      <Box
        position="absolute"
        top="30%"
        left={{
          base: '60%',
          sm: '65%',
          md: '72%'
        }}
        transform="translate(-50%, -50%)"
        textAlign="center"
        pt={{ base: '50px', sm: '20px', md: 0 }}
      >
        <Text
          fontFamily="Inter"
          textTransform="uppercase"
          w={{
            base: 200,
            sm: 240,
            md: 280
          }}
          textAlign="right"
          textStyle="docOrderTitle"
        >
          Order online right now!
        </Text>
        <Link
          href="/products/doctorcos-snow-white-water-glow-mask"
          style={{ display: 'contents' }}
        >
          <Button
            fontFamily="Inter"
            variant="ghost"
            textTransform="uppercase"
            fontWeight={400}
            background="white"
            color="#E7CD7E"
            border="4px solid #E7CD7E"
            borderRadius={40}
            fontSize={{
              base: 18,
              sm: 20,
              md: 24
            }}
            mt={2}
            ml={{
              base: '60px',
              sm: '74px',
              md: 24
            }}
            pl={4}
            pr={0}
            py={{
              base: 2,
              sm: 5,
              md: 6
            }}
            display="flex"
            alignItems="center"
          >
            <HStack gap={0} justifyContent={'center'}>
              <Box>Buy Now</Box>
              <ChevronRightIcon
                w={{
                  base: 6,
                  sm: 8,
                  md: 10
                }}
                h={{ base: 6, sm: 8, md: 10 }}
                color="red.500"
              />
            </HStack>
          </Button>
        </Link>
      </Box>
    </HStack>
  )
}

export default Order
